export const specials = [
  {
    id: "sp-001",
    title: "年度必看电影盘点",
    subtitle: "2026 值得反复回味的大银幕时刻",
    description:
      "从恢弘历史到硬核科幻，从都市情感到温情家庭，我们从上一年度众多作品中精选出一批口碑与品质俱佳的影片。它们或许风格迥异，却都在某一刻击中过观众的心。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20cinematic%20collage%20of%20a%20grand%20movie%20theater%20with%20glowing%20warm%20amber%20lights%20and%20dramatic%20deep%20blue%20shadows%2C%20rich%20atmospheric%20haze%2C%20painterly%20editorial%20illustration%2C%20high%20detail%2C%20no%20text&width=1400&height=700&seq=special-cover-001&orientation=landscape",
    groups: [
      {
        title: "史诗与历史",
        description: "在时代的洪流里，看见个体最动人的微光。",
        movieIds: ["mv-001", "mv-002", "mv-003"],
      },
      {
        title: "科幻与想象",
        description: "用想象抵达现实的边界，叩问人性与技术。",
        movieIds: ["mv-004", "mv-010"],
      },
      {
        title: "温情与治愈",
        description: "生活的褶皱里，总藏着让人鼻酸又温暖的瞬间。",
        movieIds: ["mv-007", "mv-005", "mv-008"],
      },
    ],
  },
  {
    id: "sp-002",
    title: "高口碑悬疑剧集推荐",
    subtitle: "一口气刷完的烧脑体验",
    description:
      "悬疑剧的魅力，在于它总能让观众忍不住反复推敲。这份专题集合了近年来口碑出色的国产悬疑剧集，节奏紧凑、细节扎实、反转合理，是追剧党的不二之选。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20moody%20cinematic%20interior%20of%20a%20dim%20interrogation%20room%20with%20a%20single%20warm%20overhead%20lamp%20and%20deep%20blue-grey%20shadows%2C%20atmospheric%20haze%2C%20painterly%20editorial%20illustration%2C%20high%20detail%2C%20no%20text&width=1400&height=700&seq=special-cover-002&orientation=landscape",
    groups: [
      {
        title: "刑侦破案",
        description: "每一集都是一场智力博弈。",
        movieIds: ["tv-002", "mv-006"],
      },
      {
        title: "人心谜题",
        description: "真正的悬念，往往藏在人心深处。",
        movieIds: ["tv-008", "tv-007"],
      },
    ],
  },
  {
    id: "sp-003",
    title: "古装武侠的东方美学",
    subtitle: "刀光剑影里的浪漫与江湖",
    description:
      "当武侠遇上考究的服化道与实景山水，东方美学便有了具体的模样。本专题带你走近近年最具质感的古装武侠作品，感受那份独属于江湖的快意与深情。",
    cover:
      "https://readdy.ai/api/search-image?query=Panoramic%20misty%20oriental%20landscape%20with%20tiered%20pagoda%20roofs%2C%20bamboo%20groves%20and%20a%20solitary%20figure%20in%20flowing%20robes%2C%20deep%20jade%20green%20and%20warm%20gold%2C%20soft%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1400&height=700&seq=special-cover-003&orientation=landscape",
    groups: [
      {
        title: "江湖与侠义",
        description: "快意恩仇之间，叩问何为真正的侠。",
        movieIds: ["tv-006", "mv-002"],
      },
      {
        title: "家族与时代",
        description: "在一砖一瓦、一颦一笑里，看见传承。",
        movieIds: ["tv-001"],
      },
    ],
  },
];